import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useContext, useState } from 'react'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import dashboardStyles from '../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import styles from "../../../../../assets/styles/componentStyles/ticketStyles/ticket.module.scss";
import { useShallow } from 'zustand/react/shallow';
import { useTicketStore } from '../../../../../store/ticketStore';
import { formatDateAccordingToTimezoneUsingMoment, hasTicketSubstatusManageAccess } from '../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import GlobalMenu from '../../../../globalMenu';
import { globalMenuItemData, ticketStatusData } from '../../../../../models/axiosModel';
import globalStrenameDocumentyles from "../../../../../assets/renameDocument.svg";
import deleteDoc from "../../../../../assets/deleteDoc.svg";
import GlobalDeletePopup from '../../../../utility/globalDeletePopup/globalDeletePopup';
import agent from '../../../../../services/api';
import { useGenericStore } from '../../../../../store/genericStore';

interface TicketSubStatusTableProps {
    getTicketStatusListApiCall: () => Promise<void>,
} 

const TicketSubStatusTable: React.FC<TicketSubStatusTableProps> = (props) => {
    
    const { getTicketStatusListApiCall } = props;
    const innerHeight = window.innerHeight - 200;

    const { userDetail, setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { ticketStatusData, setFlagCreateSubStatusPopup, setSelectedSubStatus, selectedSubStatus, filterStatusesBySubstatusFlag } = useTicketStore(
        useShallow((state) => ({
            ticketStatusData: state.ticketStatusData,
            setFlagCreateSubStatusPopup: state.setFlagCreateSubStatusPopup,
            setSelectedSubStatus: state.setSelectedSubStatus,
            selectedSubStatus: state.selectedSubStatus,
            filterStatusesBySubstatusFlag: state.filterStatusesBySubstatusFlag
        }))
    )

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement | SVGSVGElement>(null);
    const [currentRowIndex, setCurrentRowIndex] = useState<number | string | null>(null);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement | SVGSVGElement, MouseEvent>, rowIndex: number | string) => {
        setCurrentRowIndex(rowIndex);
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setCurrentRowIndex(null);
    };

    const menuItems: globalMenuItemData[] = [
        {
            type: "item",
            label: "Edit",
            icon: <img alt="" src={globalStrenameDocumentyles} />,
            onClick: (status: ticketStatusData) => { setFlagCreateSubStatusPopup(true); setSelectedSubStatus(status); }
        },
        {
            type: "item",
            label: "Delete",
            icon: <img alt="" src={deleteDoc} />,
            onClick: (status: ticketStatusData) => { setShowDeleteConfirmation(true); setSelectedSubStatus(status); }
        }
    ]

    const deleteTicketSubStatus = async () => {
        if(selectedSubStatus){
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            const res = await agent.deleteTicketSubStatus.delete(selectedSubStatus?.ticket_status_id);
            if(!(res.status)){
                handleError(res);
            } else {
                showSuccess('Ticket Substatus Deleted Successfully')
                getTicketStatusListApiCall();
            }
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }
    
    return (
        <>
            <TableContainer className={`${globalStyles.WritewizGlobaltable} ${globalStyles.overflowAuto}`} sx={{ maxHeight: `${innerHeight}px !important` }}>
                 <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Name</TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Color</TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Updated At</TableCell>
                            {hasTicketSubstatusManageAccess(userDetail) && 
                                <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle} ${dashboardStyles.viewButtonColumnHeadingStyle} ${globalStyles.textItemsEnd}`}></TableCell>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(ticketStatusData && filterStatusesBySubstatusFlag(true)?.length > 0) ?
                            filterStatusesBySubstatusFlag(true)?.map((status, ind) => {
                                return (
                                    <TableRow className={dashboardStyles.cellRow} key={status?.ticket_status_id}>
                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{status?.ticket_status_name}</TableCell>
                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                            <Grid container className={globalStyles.displayFlex} gap={1} flexWrap={"nowrap"}>
                                                <Grid item className={styles.ticketStatusColorGridBox} sx={{ backgroundColor: `${status?.ticket_status_color} !important` }}>
                                                </Grid>
                                                <Grid item>
                                                    {status?.ticket_status_color}
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{formatDateAccordingToTimezoneUsingMoment(status?.updated_timestamp, userDetail?.timezone_hour)}</TableCell>
                                        {hasTicketSubstatusManageAccess(userDetail) && 
                                            <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${dashboardStyles.viewButtonColumnStyle}`} sx={{textAlign: "end"}}>
                                                <MoreVertIcon
                                                    className={globalStyles.clickable}
                                                    onClick={(e: React.MouseEvent<HTMLElement | SVGSVGElement, MouseEvent>) => { e?.stopPropagation(); handleMenuOpen(e, status?.ticket_status_id) }}
                                                />
                                                <GlobalMenu
                                                    anchorEl={anchorEl}
                                                    handleMenuClose={handleMenuClose}
                                                    menuItemData={menuItems}
                                                    open={Boolean(anchorEl) && currentRowIndex === status?.ticket_status_id}
                                                    additionalField={status}
                                                />
                                            </TableCell>
                                        }
                                    </TableRow>
                                );
                            })
                            :
                            <TableRow className={dashboardStyles.cellRow}>
                                <TableCell colSpan={12} className={globalStyles.textCenter}>
                                    No Data Available
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            {showDeleteConfirmation &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${selectedSubStatus?.ticket_status_name} substatus`}
                    open={showDeleteConfirmation}
                    onClose={() => { setShowDeleteConfirmation(false); setSelectedSubStatus(null); }}
                    onDelete={() => {
                        deleteTicketSubStatus();
                        setShowDeleteConfirmation(false);
                        setSelectedSubStatus(null);
                    }}
                />
            }
        </>
    )
}

export default TicketSubStatusTable
